import { CustomPageHeader, Text } from '@src/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BaBsList from './BaBsList';

const BaBs = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [dispatch]);

    return (
        <CustomPageHeader
            data-testid="baBs"
            title={<Text t="baBsConsensus" />}
            showBreadCrumb
            showHelpButton
            routes={['myInvoices']}
        >
            <BaBsList />
        </CustomPageHeader>
    );
};

export default BaBs;
